import types from './types';
import UserModel from 'src/model/user.model';
import tokenService from 'src/services/token/TokenService';
import accountService from 'src/services/account/accountService';
import userService from 'src/services/user/userService';
import { IWarrantyError } from '../accountview/reducers';
import InvoiceService from 'src/services/invoice/InvoiceService';
import { signInActions } from 'src/store/modules/signin';
import contactVerificationServiceInstance from 'src/services/contactVerification/contactVerification';
import { default as userActions } from 'src/store/modules/user/actions';
import {
  goToAccountInfo,goToAccount, goToHome
} from 'src/utils/navigation';
import * as React from 'react';

import { analyticsActions } from 'src/analytics/store';

const setIsPending = (isPending: boolean) => {
  return {
    type: types.SET_USER_IS_PENDING,
    payload: isPending ? isPending : false
  };
};

const setError = (error?: IWarrantyError) => {
  return {
    type: types.SET_USER_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const updateEmail = (emailUpdated?: any) => {
  return {
    type: types.EMAIL_UPDATED,
    payload: emailUpdated
  };
};

const getUserDetails = (): any => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(getUserAccountsIsPending(true));
    userService
      .getUserDetails()
      .then(res => {
        tokenService.getAccessToken().then(response => {
          const tokenResponse: UserModel = userService.castTokenToClass(
            tokenService.decodeToken(response.toString())
          );
          const data = {
			...tokenResponse,
			name: res.name,
			email: res.email,
			mobileNumber: res.mobileNumber,
			clientIdentity: res.clientIdentity,
			address: res.address,
			billingAddress: res.billingAddress,
			accountCredit: res.accountCredit,
			warehouseInfo: res.warehouseInfo,
			defaultMannerOfTransport: res.defaultMannerOfTransport,
      partsmartUsername: res.partsmartUsername,
      partsmartEmail: res.partsmartEmail,
			ponumberRequired: res.ponumberRequired,
			pickup: res.pickup,
			paymentMethods: res.paymentMethods,
			isDelivery: res.isDelivery,
			creditStopCode: res.creditStopCode,
			mobileValid: res.mobileValid,
			emailValid: res.emailValid,
			emailSkipCount: res.emailSkipCount,
			emailValidSkipCount: res.emailValidSkipCount,
			userValidationEligible:res.userValidationEligible,
      specialUserEmail:res.specialUserEmail
		  };
		  if (res) {
			localStorage.setItem('-emailVerify', res.emailValid.toString());
      localStorage.setItem('-mobileVerify', res.mobileValid.toString());
			localStorage.setItem('-userValidationEligible', res.userValidationEligible.toString());
			
		  }
          if (!res.warehouseInfo && !res.isDelivery) {
            document.body.classList.add('special-body-easy-notification');
          } else if (localStorage.getItem('isSamsungUser')) {
            document.body.classList.add('special-body-easy-notification');
          }
          dispatch(getUserAccountsIsPending(false));
          dispatch(userData(data));
          dispatch(analyticsActions.sendUserData(data)); 
          // added for show loader on login page until user not logged in    
          dispatch(setIsPending(false));   
        });
      })
      .catch((e: any) => {
        dispatch(getUserAccountsIsPending(false));
        dispatch(userDataError(e));
      });
  };
};

const getUserAccounts = (): any => {
  return (dispatch: any) => {
    accountService.getUserAccounts().then(response => {
      dispatch({ type: types.USER_ACCOUNTS, payload: response });
    });
  };
};

const searchUserAccounts = (
  search: string,
  page?: number,
  size?: number
): any => {
  return (dispatch: any) => {
    dispatch(getUserAccountsIsPending(true));
    accountService.searchUsers(search, page, size).then((response: any) => {
      dispatch({ type: types.USER_ACCOUNTS, payload: response.data });
      dispatch({
        type: types.USER_ACCOUNTS_PAGINATION,
        payload: {
          pageNumber: response.pageNumber,
          total: response.totalPages,
          size: response.pageSize
        }
      });
      dispatch(getUserAccountsIsPending(false));
    });
  };
};

const getUserAccountsIsPending = (isPending: boolean): any => {
  return { type: types.USER_ACCOUNTS_IS_PENDING, payload: isPending };
};

const removeUserData = (): any => {
  return { type: types.USER_DATA, payload: {} };
};

const userData = (data: UserModel) => {
  return { type: types.USER_DATA, payload: data };
};

const userDataError = (error: { code?: number; message?: string }) => {
  return { type: types.USER_DATA_ERROR, payload: error };
};

const allowModifyInvoices = (
  accountId: string,
  clientIdentity: string,
  allow: boolean
) => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    if (allow) {
      InvoiceService.allowUserModifyInvoices(accountId, clientIdentity)
        .then(res => {
          dispatch(getUserAccounts());
          dispatch(setError());
        })
        .catch(err => {
          dispatch(
            setError({
              hasFailed: true,
              message: "Couldn't change permission."
            })
          );
          dispatch(setIsPending(false));
        });
    } else {
      InvoiceService.disableUserModifyInvoices(accountId, clientIdentity)
        .then(res => {
          dispatch(getUserAccounts());
          dispatch(setError());
        })
        .catch(err => {
          dispatch(
            setError({
              hasFailed: true,
              message: "Couldn't change permission."
            })
          );
          dispatch(setIsPending(false));
        });
    }
  };
};

const updateUserInfo = (email: string, phone: string) => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    userService
      .updateUserInfo(email, phone)
      .then(res => {
        dispatch(getUserDetails());
        dispatch(signInActions.setShouldUpdateInfo(false));
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: false,
            message: ''
          })
        );
        dispatch(updateEmail({ isEmailUpdated: true }));          
      })
      .catch((e: any) => {
        dispatch(setIsPending(false));
        dispatch(
          setError({
            hasFailed: true,
            message: e.response ? e.response.data.message : e
          })
        );
        dispatch(updateEmail({ isEmailUpdated: false }));
      });
  };
};

export default {
  // getUserData,
  removeUserData,
  userData,
  userDataError,
  getUserAccounts,
  getUserDetails,
  allowModifyInvoices,
  searchUserAccounts,
  updateUserInfo,
  updateEmail
};
